module.exports = __webpack_public_path__ + "static/media/IKMS11.0d54eb5b.jpg";